module.exports = __webpack_public_path__ + "app-static/img/T1.bba5d113.png";